import "core-js/stable";
import React, {useContext, useEffect} from 'react';
import {render} from 'react-dom';
import {BrowserRouter, Switch, withRouter} from 'react-router-dom';
import "../../../css/index.scss";
import {MessagePopupCore} from '@dts-soldel/dts-react-common';
import Pages, {renderPageRoutes} from "../../app/pages/Pages";
import ContextProvider from "../ContextProvider";
import MobXContext from "../../app/mobx/MobXContext";
import {observer} from "mobx-react";
import Headers from "./Headers";
import UtahHeader from "../UtahHeader/UtahHeader";
import LocalStorage from "../../app/localstorage/LocalStorage";
import utahHeaderLoaded from "../UtahHeader/utahHeaderLoaded";
import updateHeaderWithConfig from "../../app/utahHeader/updateHeaderWithConfig";
import contextBasedValue from "../../app/contextBased/contextBasedValue";
import contextBasedEnvironments from "../../app/contextBased/contextBasedEnvironments";
import packageJson from "../../../../../package";

const App = ({history}) => {
	const {configuratorStore, historyStore} = useContext(MobXContext);

	useEffect(() => {
		if (!history) {
			console.error("history does not exist for app");
		}
		historyStore.history = history;

		configuratorStore.loadFromJSON(LocalStorage.config.get('{}'));
		utahHeaderLoaded.then(() => updateHeaderWithConfig(configuratorStore));
	}, []);

	// use 'latest' version of library if on a 'latest' url; 'latest' is default if undefined
	const utahHeaderVersion = window.location.href.includes('latest') ? undefined : packageJson.version;

	return (
		<>
			<UtahHeader
				// Use the following to test in a local environment such as on a Windows VM
				// Replace "localhost" with the IP Address of the host computer
				// utahHeaderVersion="local"
				// utahHeaderUrl="http://localhost:9000/utahHeader.bundle.js"
				{
					...contextBasedValue({
						[contextBasedEnvironments.LOCAL]: {utahHeaderUrl: "http://localhost:9100/utahHeader.bundle.js"},
						[contextBasedEnvironments.DEV]: {utahHeaderVersion},
						[contextBasedEnvironments.AT]: {utahHeaderVersion},
						[contextBasedEnvironments.PROD]: {utahHeaderVersion},
					})
				}
			>
				<Headers/>
				<Switch>
					{renderPageRoutes(Pages.public)}
				</Switch>
				<MessagePopupCore/>
			</UtahHeader>
		</>
	);
};

// create react div
const div = document.createElement('div');
div.id = 'react-app';
div.className = 'react-app';
document.body.appendChild(div);

// This will correctly set the basename so router works, if you're using an awesome vhost or not
const examples = '/examples';
const examplePos = window.location.pathname.indexOf(examples);
const baseName = examplePos === -1 ? '/' : window.location.pathname.substr(0, examplePos + examples.length);

const WrappedApp = withRouter(observer(App));

// all together now!
render(<BrowserRouter basename={baseName}><ContextProvider><WrappedApp/></ContextProvider></BrowserRouter>, div);
